// Login page component

import React from 'react';
import {
  Box,
  Typography,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LoginForm from './components/LoginForm';

export default function LoginPage() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleForgotPassword = () => {
    navigate('/forgot-password');
  };

  const handleRegister = () => {
    navigate('/register');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
      }}
    >
      {/* Header - Removed per user request */}

      {/* Main Content */}
      <Box
        sx={{ 
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: { xs: 2, md: 3 },
          py: { xs: 2, md: 3 }
        }}
      >
        <LoginForm 
          onForgotPassword={handleForgotPassword}
          onRegister={handleRegister}
        />
      </Box>

      {/* Footer */}
      <Box
        sx={{
          py: 2,
          textAlign: 'center',
          color: 'white',
          opacity: 0.8
        }}
      >
        <Typography variant="body2">
          © 2024 BiuroStock Manager. Wszystkie prawa zastrzeżone.
        </Typography>
      </Box>
    </Box>
  );
}